import type { Locale } from "./Locale";

import { createContext, useContext } from "react";

const LocaleContext = createContext<Locale | null>(null);

export function useLocale() {
  const context = useContext(LocaleContext);
  if (!context) {
    throw new Error("LocaleContext used without initialization");
  }
  return context;
}

export function LocaleProvider({
  locale,
  children,
}: {
  locale: Locale;
  children: React.ReactNode;
}) {
  return <LocaleContext.Provider value={locale}>{children}</LocaleContext.Provider>;
}
